import RecentTickets from "./dashboardSubComponents/ticketsReview/RecentTickets";
import RecentUsers from "./dashboardSubComponents/usersReview/RecentUsers";
import { DashboardOperationsContainer, RecentUsersContainer } from "./style";
import MiniCards from "./dashboardSubComponents/miniCards/MiniCards";
import CustomLineChart from "./dashboardSubComponents/customLineChart/CustomLineChart";
import { useAuth } from "../../../../utils/hooks/useAuth";
import { useDispatch } from "react-redux";
import { useGetTicketsByAdminIdQuery } from "../../../../redux/features/tickets/ticketsApi";
import { useEffect, useState } from "react";
import { getTicketsList } from "../../../../redux/features/tickets/ticketsSlice";
import { useGetUsersByAdminIdQuery } from "../../../../redux/features/usersManagement/usersManagementApi";
import { getUsersList } from "../../../../redux/features/usersManagement/usersManagementSlice";
import {
  useGetGroupedProjectsByAdminIdQuery,
  useGetProjectsByAdminIdAndStatusQuery,
} from "../../../../redux/features/projects/projectsApi";
import { SkeletonLoading } from "../../../common/SkeletonLoading";
import ColumnContainer from "../../../common/ColumnContainer";

export default function DashboardAdmin() {
  const { auth } = useAuth();
  const dispatch = useDispatch();
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  const {
    data: ticketsData,
    isLoading: ticketsLoading,
    isError: ticketsError,
  } = useGetTicketsByAdminIdQuery(
    {
      adminId: auth?.userData?.id,
      page: 1,
      queryFilters: {
        ticket_status: null,
        category: null,
        company_name: null,
        updated_at: null,
        created_at: null,
      },
    },
    {
      skip: !auth?.userData?.id,
    }
  );

  const {
    data: usersData,
    isLoading: usersLoading,
    isError: usersError,
  } = useGetUsersByAdminIdQuery(
    {
      admin_id: auth?.userData?.id,
      page: 1,
      statusFilter: "all",
    },
    {
      skip: !auth?.userData?.id,
    }
  );

  const { data: statisticsProjects, isLoading: statisticsLoading } =
    useGetGroupedProjectsByAdminIdQuery(
      {
        adminId: auth?.userData?.id,
      },
      {
        skip: !auth?.userData?.id,
      }
    );

  const { data: statusProjects, isLoading: statusProjLoading } =
    useGetProjectsByAdminIdAndStatusQuery(
      {
        adminId: auth?.userData?.id,
        projectStatus: "new",
      },
      {
        skip: !auth?.userData?.id,
      }
    );

  // EFFECTS

  useEffect(() => {
    if (
      ticketsData &&
      !ticketsLoading &&
      !ticketsError &&
      usersData &&
      !usersLoading &&
      !usersError &&
      statisticsProjects &&
      !statisticsLoading &&
      statusProjects &&
      !statusProjLoading
    ) {
      dispatch(getTicketsList(ticketsData));
      dispatch(getUsersList(usersData));
      setIsDataLoaded(true);
    }
  }, [
    ticketsData,
    ticketsLoading,
    ticketsError,
    usersData,
    usersLoading,
    usersError,
    statisticsProjects,
    statisticsLoading,
    statusProjects,
    statusProjLoading,
    dispatch,
  ]);

  return (
    <DashboardOperationsContainer>
      {!isDataLoaded ? (
        <SkeletonLoading type="dashboard" />
      ) : (
        <ColumnContainer>
          <MiniCards statusProjects={statusProjects} />
          <RecentUsersContainer>
            <RecentUsers users={usersData} />
            <RecentTickets tickets={ticketsData} />
          </RecentUsersContainer>
          <CustomLineChart statisticsProjects={statisticsProjects} />
        </ColumnContainer>
      )}
    </DashboardOperationsContainer>
  );
}
